import {MathUtils} from '../../../../shared/utils/MathUtils.ts'

export class UIScrollController {
    protected contentDiv: HTMLDivElement
    private readonly sidebarDiv: HTMLDivElement
    private readonly viewportDiv: HTMLDivElement
    private readonly currentSectionLinkClass: string
    private currentSectionLink: HTMLAnchorElement | null = null

    constructor(contentDiv: HTMLDivElement, sidebarDiv: HTMLDivElement, viewportDiv: HTMLDivElement = contentDiv, currentSectionLinkClass: string = 'active') {
        this.contentDiv = contentDiv
        this.sidebarDiv = sidebarDiv
        this.viewportDiv = viewportDiv
        this.currentSectionLinkClass = currentSectionLinkClass

        this.handleUrlHash()

        this.onContentScroll()
        if(this.currentSectionLink !== null) return
        this.selectFirstLink()
    }

    private handleUrlHash() {
        const hash = window.location.hash
        const section = UIScrollController.getSectionFromHash(hash)
        this.scrollToSection(section)
    }

    protected onSidebarClick(event: MouseEvent) {
        event.preventDefault()

        if(event.target === null) return
        if(!(event.target instanceof HTMLElement)) return

        const linkElement = event.target.closest<HTMLAnchorElement>('a')
        if(linkElement === null) return

        const section = UIScrollController.getSectionFromHash(linkElement.href)
        this.scrollToSection(section)
    }

    private static getSectionFromHash(hash: string) {
        const sectionId = hash.split('#')[1]
        return document.getElementById(sectionId)
    }

    protected onContentScroll() {
        if(this.contentDiv == undefined) return

        const children = Array.from(this.contentDiv.children)
        const maxTopPosition = this.contentDiv.scrollHeight - this.viewportDiv.clientHeight
        const elementsInView = children.filter((child: HTMLElement) => {
            const childStyles = getComputedStyle(child)
            if(childStyles.display === 'none') return false
            if(childStyles.visibility === 'hidden') return false

            const validLocationForElement = child.offsetTop / this.contentDiv.scrollHeight * maxTopPosition
            return validLocationForElement < this.viewportDiv.scrollTop
        })

        const target = elementsInView[elementsInView.length - 1]
        if(target === undefined) return
        if(target.id === '') return

        const linkElement = this.sidebarDiv.querySelector<HTMLAnchorElement>(`a[href="#${target.id}"]`)
        if(linkElement === null) return

        this.setCurrentSectionLink(linkElement)
    }

    private setCurrentSectionLink(linkElement: HTMLAnchorElement) {
        if(this.currentSectionLink === linkElement) return
        if(this.currentSectionLink) this.currentSectionLink.classList.remove(this.currentSectionLinkClass)
        this.currentSectionLink = linkElement
        this.currentSectionLink.classList.add(this.currentSectionLinkClass)
    }

    private scrollToSection(section: HTMLElement | null) {
        if(section == null) return

        const maxTopPosition = this.contentDiv.scrollHeight - this.viewportDiv.clientHeight
        const scrollYMin = section.offsetTop / this.contentDiv.scrollHeight * maxTopPosition
        const scrollYMax = Math.floor(scrollYMin + section.scrollHeight / this.contentDiv.scrollHeight * maxTopPosition)
        const scrollY = MathUtils.clamp(section.offsetTop, scrollYMin, scrollYMax)
        this.viewportDiv.scroll(0, scrollY)
    }

    private selectFirstLink() {
        if(this.sidebarDiv == undefined) return
        const firstLink = this.sidebarDiv.querySelector<HTMLAnchorElement>('a')
        if(firstLink === null) return

        this.setCurrentSectionLink(firstLink)
    }
}
